import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface Props {
  children?: React.ReactNode;
}

export type PageTitleType = Props & TypographyProps;

const PageTitle: React.FC<PageTitleType> = ({ children, variant = 'h5', gutterBottom = true, ...typographyProps }) => {
  return (
    <Typography variant={variant} gutterBottom={gutterBottom} {...typographyProps}>
      {children}
    </Typography>
  );
};

export default PageTitle;
